module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c813c12e83ecc80fa1ba8f60752db9a3.png";